// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f713d6f","455":"dc0b47fe"}[chunkId] + ".chunk.js";
};